<template>
	<div class="filter-bar">

		<div class="d-flex flex-column mb-4">
			<div class="mb-1 fw-bold">Sök efter produkt</div>
			<input type="text" class="form-control search-input" placeholder="Snabbsök..." v-model="filter.text" />
		</div>


		<div class="section">
			<div class="title" data-bs-toggle="collapse" href="#collapseCategories" role="button" aria-expanded="true" aria-controls="collapseCategories">
				Kategorier
			</div>
			<div class="collapse show" id="collapseCategories">
				<div class="category-option"
					 :class="{active: filter.category === category}"
					 v-for="category in filterCategoriesMap"
					 @click="filter.category = category; triggerScroll()">

					{{ category.text }} ({{ numProductsWithCategory(category) }})
				</div>
			</div>
		</div>

		<div class="section">
			<div id="anchor" ref="anchor"></div>
			<div class="title" data-bs-toggle="collapse" href="#collapseMore" role="button" aria-expanded="false" aria-controls="collapseMore">
				Noggrannare sökning
			</div>
			<div class="collapse show" id="collapseMore">

				<div class="title tiny" data-bs-toggle="collapse" href="#collapseBrands" role="button" aria-expanded="false" aria-controls="collapseBrands">
					Märke
				</div>
				<div class="collapse" id="collapseBrands">
					<div class="card border-0 bg-light">
						<div class="card-body">
							<div class="misc-option"
								 :class="{active: filter.brand === brand}"
								 v-for="brand in filterOptions.brands"
								 @click="filter.brand = brand"
							>
								{{ brand.text }} ({{ brand.num_ads }})
							</div>
						</div>
					</div>
				</div>

				<div class="title tiny" data-bs-toggle="collapse" href="#collapseLocations" role="button" aria-expanded="false" aria-controls="collapseLocations">
					Uppställningsplats
				</div>
				<div class="collapse" id="collapseLocations">
					<div class="card border-0 bg-light">
						<div class="card-body">
							<div class="misc-option"
								 :class="{active: filter.location === location}"
								 v-for="location in filterOptions.locations"
								 @click="filter.location = location"
							>
								{{ location.text }} ({{ location.num_ads }})
							</div>
						</div>
					</div>
				</div>

				<div class="title tiny" data-bs-toggle="collapse" href="#collapseYear" role="button" aria-expanded="false" aria-controls="collapseYear">
					Tillverkningsår
				</div>
				<div class="collapse" id="collapseYear">
					<input-multi-range
						id="yearOfManufactures"
						:step="1"
						v-model:from="filter.yearofmanufacture.from"
						v-model:to="filter.yearofmanufacture.to"
						:min="filterOptions.min_yearofmanufacture"
						:max="filterOptions.max_yearofmanufacture"
						:cleave-options="{blocks: [4]}"
					/>
				</div>

				<div class="title tiny" data-bs-toggle="collapse" href="#collapsePrice" role="button" aria-expanded="false" aria-controls="collapsePrice">
					Pris (SEK)
				</div>
				<div class="collapse" id="collapsePrice">
					<input-multi-range
						id="price"
						:step="1000"
						v-model:from="filter.priceoriginal.from"
						v-model:to="filter.priceoriginal.to"
						:min="0"
						:max="filterOptions.maxPrice"
						:cleave-options="{ numeral: true, numeralDecimalMark: ',', delimiter: ' ', numeralPositiveOnly: true }"
					/>
				</div>

				<div class="title tiny" data-bs-toggle="collapse" href="#collapseMeter" role="button" aria-expanded="false" aria-controls="collapseMeter">
					Drifttimmar
				</div>
				<div class="collapse" id="collapseMeter">
					<input-multi-range
						id="meterreadouthours"
						:step="100"
						v-model:from="filter.meterreadouthours.from"
						v-model:to="filter.meterreadouthours.to"
						:min="0"
						:max="filterOptions.max_meterreadouthours"
						:cleave-options="{ numeral: true, numeralDecimalMark: ',', delimiter: ' ', numeralPositiveOnly: true }"
					/>
				</div>

			</div>

		</div>

	</div>
</template>

<script>
import { filterCategoriesMap } from './map'

import mixins from './mixins'

import single from './single'
import InputMultiRange from './input-multi-range'

export default {

	mixins: [mixins],

	components: {
		InputMultiRange,
		single,
	},

	props: {
		modelValue: {
			required: true
		},
		filterOptions: {
			required: true
		},
		products: {
			required: true
		}
	},

	//emits: ['update:modelValue'],

	data() {
		return {
			filterCategoriesMap: filterCategoriesMap,
			filter: this.modelValue,
		}
	},

	mounted() {
		this.$emit("mounted");

		const scroll = () => {
			if (typeof anchorLinkMobile !== 'undefined' && anchorLinkMobile) {
				const targetElement = document.getElementById(anchorLinkMobile);

				if (targetElement) {
					targetElement.scrollIntoView({ behavior: 'smooth' });
				}
			}
		}

		if(window.innerWidth < 768) {
			setTimeout(() => {
				scroll();
			}, 1000);
		}
	},

	watch: {

	},

	computed: {},

	methods: {
		numProductsWithCategory(category) {
			return this.products.filter(product => {
				return category.contains.indexOf(product.custom.category) !== -1
			}).length
		},
		triggerScroll() {
			if(window.innerWidth > 761) return

			$("html, body").animate(
				{
					scrollTop: $("#product-grid-mascus").offset().top
				},
				100
			);
		}
	}
}
</script>
